import { useEffect, useState } from "react";
import { getUser } from "../../config/user";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import Select from "react-select";
import { OtpServices } from "../../services/OtpServices";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

const DmLogReport = () => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [dmLogsData, setDmLogsData] = useState(null);
  const [otpStatus, setOtpStatus] = useState("SUCCEEDED");
  const limit = 20;
  const user = getUser();
  const { newOtpMessage } = useSelector((store) => store.notificationReducer);

  const getDmLogData = async () => {
    setLoading(true);
    try {
      const res = await OtpServices.getDmOtpLogsSummary(
        page,
        limit,
        searchKey,
        user?.hospital?.id,
        null,
        "2025-07-21T06:12:34.000Z",
        null
      );
      let modifiedData = [];
      for (let log of res?.data?.dmUserLog) {
        for (let numLog of log?.dmapplogs) {
          if (numLog.attempts > 1 && numLog.otpStatus == "SUCCEEDED") {
            modifiedData.push({ ...numLog, otpStatus: "MULTIATTEMPTS" });
          } else {
            modifiedData.push(numLog);
          }
        }
      }
      setDmLogsData(modifiedData);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getDmLogData();
  }, [newOtpMessage]);
  return (
    <div>
      {" "}
      <div
        style={{ color: "rgba(0,0,0,0.5)" }}
        className="text-[11px] 2xl:text-sm leading-[18.27px] -tracking-[3%]"
      >
        Home / DM Log Report
      </div>
      <div className="w-fit text-[30px] 2xl:text-[50px] leading-[65.26px] -tracking-[7%]  mt-[12px] 2xl:mt-[30px]">
        DM Logs
      </div>
      <div
        id="case-list"
        style={{ background: "rgba(255,255,255,0.5)" }}
        className="p-4 2xl:p-8 mt-1 2xl:mt-4 rounded-[30px] min-h-[70vh]"
      >
        <div className="flex justify-between">
          <div className="text-[20px] 2xl:text-[30px]   -tracking-[7%] ">
            {otpStatus}
          </div>
          <Select
            options={[
              { value: "SUCCEEDED", label: "Succeeded" },
              { value: "FAILED", label: "Failed" },
              { value: "MULTIATTEMPTS", label: "Multiple Attempts" },
            ]}
            value={[
              { value: "SUCCEEDED", label: "Succeeded" },
              { value: "FAILED", label: "Failed" },
              { value: "MULTIATTEMPTS", label: "Multiple Attempts" },
            ].filter((item) => item.value === otpStatus)}
            onChange={(item) => setOtpStatus(item.value)}
            placeholder="Please select the OTP status type"
          />
        </div>
        <div
          style={{
            border: "1px solid #FFFFFF",
          }}
          className="mt-[32px] 2xl:mt-[40px] mb-[24px] 2xl:mb-[30px]"
        />
        <div className="bg-[white] p-[24px] 2xl:p-[30px] rounded-[15px]">
          <div className="grid grid-cols-7 text-[12px] 2xl:text-sm font-semibold 2xl:leading-[21.7px] -tracking-[3%]">
            <div>Mobile Number</div>
            <div>Attempts</div>
            <div>Otp Status</div>
            <div>OTP Received Time</div>
            <div className="col-span-3">Detail and Reason</div>
          </div>
          {loading ? (
            <div className="h-[200px] flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <div>
              {dmLogsData &&
              dmLogsData?.filter((log) => log.otpStatus === otpStatus)?.length >
                0 ? (
                dmLogsData
                  ?.filter((log) => log.otpStatus === otpStatus)
                  ?.map((log, idx) => {
                    return (
                      <div key={idx}>
                        <div className="grid grid-cols-7 text-[12px] 2xl:text-sm font-semibold 2xl:leading-[21.7px] -tracking-[3%]  py-1 items-center mt-[8px] 2xl:mt-[10px] first:mt-6 2xl:first:mt-8">
                          <div>{log?.mobileNo || "--"}</div>
                          <div>{log?.attempts || "--"}</div>
                          <div>{log?.otpStatus || "--"}</div>
                          <div>
                            {new Date(log?.createdAt).toLocaleString() || "--"}
                          </div>
                          <div className="col-span-3">
                            {log?.reason || "--"}
                          </div>
                        </div>
                      </div>
                    );
                  })
              ) : (
                <div className="h-[200px] flex justify-center items-center font-semibold text-xl">
                  No OPT Logs Found
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DmLogReport;
